// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * The following are shared across all platforms and apps
 */
/**
 * The following are shared across all platforms and apps
 */
::ng-deep .modal-lg {
  max-width: 95%;
  width: 95%;
}

::ng-deep .customModalWindowClass .modal-content {
  pointer-events: auto;
}

::ng-deep .customModalWindowClass .modal-body {
  pointer-events: auto;
}

.navbar-brand {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 1rem;
  font-size: 1rem;
  width: 250px;
  margin: 0;
}

body a {
  color: #48557e;
}

#yt_header {
  background-color: #3b746b;
}

#yt_spotlight {
  background-color: #f1f1f1;
}

#yt_spotlight9 {
  background-color: #48557e;
}

#yt_spotlight7,
#yt_footer {
  background-color: #3b746b;
}

.navbar .nav-container {
  width: 97%;
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  justify-content: space-between;
}
@media (max-width: 1100px) {
  .navbar .nav-container {
    max-width: 100%;
  }
}
.navbar .button-wrapper {
  display: flex;
  flex-grow: 1;
  flex-wrap: wrap-reverse;
  align-items: center;
  height: 80px;
}
.navbar .header-tagline {
  font-family: "OpenSans-Bold";
  font-size: 20px;
  color: var(--undp-jtf-text-color);
  margin: auto;
}
@media (max-width: 1410px) {
  .navbar .header-tagline {
    font-size: 18px;
  }
}
@media (max-width: 1280px) {
  .navbar .header-tagline {
    font-size: 17px;
  }
}
@media (max-width: 1060px) {
  .navbar .header-tagline {
    font-size: 14px;
  }
}
@media (max-width: 992px) {
  .navbar .header-tagline {
    font-size: 22px;
  }
}
.navbar .form-control {
  padding: 0.75rem 1rem;
  border-width: 0;
  border-radius: 0;
}
.navbar .form-control-dark {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar .form-control-dark:focus {
  border-color: transparent;
  box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);
}
.navbar .btn-login {
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  margin-left: 20px;
  font-family: "OpenSans-Bold";
  padding: 7px 35px;
}
.navbar .btn-login:hover {
  text-decoration: none;
  opacity: 0.9;
}
@media (max-width: 1160px) {
  .navbar .btn-login {
    margin-left: 10px;
  }
}
.navbar fa-icon {
  margin-right: 4px;
}
.navbar #user-dropdown {
  text-decoration: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: -moz-fit-content;
  width: fit-content;
  padding: 0px 3px;
}
.navbar #user-dropdown:hover {
  text-decoration: none;
}
.navbar #reportDropdown .dropdown-menu {
  margin-top: 0;
  margin-left: 0;
}
.navbar #reportDropdown .create-incident-ddbtn {
  cursor: pointer;
  padding: 10px;
  color: var(--undp-jtf-link-dark-bg-hover-color);
}
.navbar .dropdown-toggle::after {
  opacity: 0.5;
}
.navbar .user-dropdown-section {
  position: relative;
}
.navbar .dropdown-menu {
  position: absolute;
  right: 10px;
  left: auto;
  top: 35px;
  margin-top: 4px;
  padding: 6px 0;
  border: 1px solid rgba(0, 47, 108, 0.12);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  background-color: #fff;
  font-size: 14px;
}
.navbar .dropdown-menu .dropdown-item {
  color: var(--undp-jtf-text-header-color, #23191b);
  background-color: #fff;
  padding: 10px 16px;
  transition: background 0.15s ease, color 0.15s ease;
}
.navbar .dropdown-menu .dropdown-item:hover, .navbar .dropdown-menu .dropdown-item:focus {
  background: rgba(0, 47, 108, 0.06);
  color: var(--undp-jtf-btn-dark-color, #002f6c);
}
.navbar .dropdown-menu.notifications-dropdown {
  right: -17px;
  left: unset;
  width: 400px;
  padding-top: 4px;
  padding-bottom: unset;
  max-height: 50vh;
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0;
}
@media (max-width: 767px) {
  .navbar .dropdown-menu.notifications-dropdown {
    width: calc(100vw + 2px);
    max-height: calc(100vh - 48px);
  }
}
.navbar .unread-notifications {
  position: absolute;
  top: 4px;
  right: 0;
  font-size: 6px;
  color: red;
}
.navbar .rightSideContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0;
}
.navbar .rightSideContainer .fa-search {
  border-right: 1px solid;
  padding-right: 20px;
  padding-left: 20px;
  cursor: pointer;
}
.navbar .header-logo {
  cursor: pointer;
  padding: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}
@media (min-width: 768px) {
  .navbar .header-logo .col-md-3 {
    flex: 0 0 25%;
    max-width: 100%;
  }
}

.navbar.bg-dark {
  background-color: #fff !important;
}

.mobile-nav {
  display: none;
  height: 70px;
  padding: 10px 20px;
}
@media (max-width: 992px) {
  .mobile-nav {
    display: block;
  }
}
@media (max-width: 560px) {
  .mobile-nav {
    padding: 10px 10px;
  }
}

.mobile-nav-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.mobile-header-logo {
  display: flex;
  flex-direction: row;
  width: -moz-fit-content;
  width: fit-content;
  align-items: center;
  font-size: 18px;
  font-family: "OpenSans-Bold";
  color: var(--undp-jtf-text-color);
}
@media (max-width: 560px) {
  .mobile-header-logo {
    font-size: 16px;
  }
}

@media (max-width: 560px) {
  .mobile-heading {
    text-align: center;
  }
}

.mobile-dropdown-icon {
  color: var(--undp-jtf-text-color);
  margin: 0px 10px;
  cursor: pointer;
}
.mobile-dropdown-icon svg {
  height: 100%;
  width: 100%;
}

.mobile-logo {
  width: 100px;
}
@media (max-width: 560px) {
  .mobile-logo {
    width: 80px;
  }
}
@media (max-width: 328px) {
  .mobile-logo {
    width: 60px;
  }
}

.mobile-dropdown {
  position: absolute;
  top: 70px;
  right: 0;
  z-index: 2;
  width: 350px;
  background: white;
  color: var(--undp-jtf-text-color);
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid var(--undp-jtf-btn-text-color);
  font-family: "OpenSans-Bold";
  max-height: 0px;
  overflow: hidden;
  box-shadow: -1px 2px 1px #d8d8d8;
}
.mobile-dropdown.mobile-dropdown-active {
  max-height: calc(100vh - 70px);
  overflow-y: auto;
}
@media (max-width: 560px) {
  .mobile-dropdown {
    width: 100%;
  }
}

.mobile-parentLink-div--active {
  background: rgba(0, 47, 108, 0.04);
}

.mobile-parentLink {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  color: var(--undp-jtf-text-color);
  padding: 12px 16px;
  border-top: 1px solid rgba(0, 47, 108, 0.12);
  border-left: 4px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.mobile-parentLink--active, .mobile-parentLink--route-active {
  border-left-color: var(--undp-jtf-btn-dark-color);
  background: rgba(0, 47, 108, 0.06);
  color: var(--undp-jtf-btn-dark-color);
  font-weight: 700;
}
.mobile-parentLink:active {
  text-decoration: none;
  color: var(--undp-jtf-text-color);
}
.mobile-parentLink input {
  position: absolute;
}

.mobile-parentLink-div {
  width: 100%;
}

.mobile-parentLink-children {
  display: none;
  max-height: 0;
  overflow: hidden;
  font-family: "OpenSans-Regular";
  background: rgba(0, 47, 108, 0.03);
  transition: max-height 0.25s ease;
}
.mobile-parentLink-children-active {
  display: block;
  max-height: 480px;
}

.mobile-childLink {
  text-decoration: none;
  display: flex;
  align-items: center;
  width: 100%;
  color: var(--undp-jtf-text-color);
  padding: 10px 16px 10px 32px;
  border-top: 1px solid rgba(0, 47, 108, 0.08);
  border-left: 4px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.mobile-childLink::before {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 10px;
  background: transparent;
  flex-shrink: 0;
  transition: background 0.15s ease;
}
.mobile-childLink--active {
  border-left-color: var(--undp-jtf-accent-color);
  background: var(--undp-jtf-accent-color);
  color: #fff;
  font-weight: 600;
}
.mobile-childLink--active::before {
  background: #fff;
}
.mobile-childLink:active {
  text-decoration: none;
}

.mobile-block {
  border-top: 1px solid var(--undp-jtf-text-color);
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
}

.mobile-block-userInfo {
  border-top: 1px solid var(--undp-jtf-text-color);
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 16px;
  font-family: "OpenSans-Bold";
  gap: 10px;
}

.mobile-login-btn {
  color: #fff;
  background-color: var(--undp-jtf-btn-dark-color);
  font-family: "OpenSans-Bold";
  padding: 3px 14px;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
}

.mobile-parentLink-caret {
  margin-right: 15px;
}
.mobile-parentLink-caret-rotate {
  transform: rotate(180deg);
}

.mobile-parentLink-div:focus-within > .mobile-parentLink-caret {
  transform: rotate(180deg);
}

.mobile-dropdown-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.main-body {
  flex-grow: 1;
}

.sidebar {
  flex-basis: 250px;
  flex-direction: column;
  display: flex;
  height: calc(100vh - 57px);
  min-width: 250px;
}
.sidebar .sidebar-sticky {
  justify-content: center;
  height: 100%;
  margin-top: 10px;
}
.sidebar .sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}
.sidebar .nav-link {
  font-weight: 500;
  color: #333;
}
.sidebar .nav-link.active {
  color: var(--undp-jtf-accent-color);
}
.sidebar .nav-link.active .feather, .sidebar .nav-link.hover .feather {
  color: inherit;
}
.sidebar .nav-link fa-icon {
  margin-right: 4px;
}
@supports (position: sticky) {
  .sidebar .sidebar-sticky {
    position: sticky;
  }
}

[role=main] {
  padding-top: 133px; /* Space for fixed navbar */
}

@media (min-width: 768px) {
  [role=main] {
    padding-top: 48px; /* Space for fixed navbar */
  }
}
@media (max-width: 688px) {
  .appLabel {
    flex-grow: 1;
  }
  .btnCreateIncident {
    margin: 1em 0.4em 0.5em 0.4em;
  }
  .navbar .button-wrapper {
    margin: 0.5em 0;
    flex-wrap: wrap-reverse;
  }
}
@media (max-width: 992px) {
  .navbar {
    display: none;
  }
  .navbar .button-wrapper {
    margin: 0.5em 0;
    flex-wrap: wrap-reverse;
  }
  .header-logo {
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: -moz-fit-content;
    width: fit-content;
    word-break: break-word;
  }
  .header-tagline {
    font-size: 22px;
    font-family: "OpenSans-Bold";
    font-weight: 500;
    color: var(--undp-jtf-text-color);
    margin: auto;
  }
  .appLabel {
    flex-grow: 1;
  }
  .btnCreateIncident {
    margin: 1em 0.4em 0.5em 0.4em;
  }
  .navbar_mobile {
    background-color: #ffffff !important;
    display: flex;
  }
  .navbar_mobile .button-wrapper {
    margin: 0.5em 0;
    flex-wrap: wrap-reverse;
  }
  .navbar_mobile .container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .navbar_mobile .bg-dark .container {
    background-color: #ffffff !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-direction: column-reverse;
  }
  .navbar_mobile .bg-dark .container {
    background-color: #ffffff !important;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    flex-direction: column-reverse;
  }
  .sideBarListText {
    font-size: 10px;
  }
  .nav-user-info {
    display: flex;
    /* Displays second level dropdowns to the right of the first level dropdown */
    /* Simple clearfix */
  }
  .nav-user-info .childItem {
    padding-left: 0;
  }
  .nav-user-info img {
    margin-left: 10px;
  }
  .nav-user-info ul {
    list-style: none;
    display: flex;
    padding: 0;
    margin: 0;
    background: #fff;
  }
  .nav-user-info ul li {
    display: block;
    position: relative;
    float: left;
    background: #fff;
  }
  .nav-user-info ul li ul {
    display: none;
  }
  .nav-user-info ul li ul li {
    z-index: 999;
  }
  .nav-user-info ul li ul li a {
    padding: 1em;
  }
  .nav-user-info ul li a {
    display: inline-block;
    padding: 5px 5px !important;
    text-decoration: none;
    white-space: nowrap;
    color: var(--undp-jtf-text-color);
  }
  .nav-user-info ul li:hover > ul {
    display: block;
    position: absolute;
  }
  .nav-user-info ul li:hover li {
    float: none;
  }
  .nav-user-info .main-navigation li ul li {
    border-top: 0;
  }
  .nav-user-info ul ul ul {
    left: 100%;
    top: 0;
  }
  .nav-user-info ul:before,
  .nav-user-info ul:after {
    content: " "; /* 1 */
    display: table; /* 2 */
  }
  .nav-user-info ul:after {
    clear: both;
  }
  .navbar_mobile .rightSideContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    flex-direction: row-reverse;
    padding-bottom: 8px;
  }
}
@media (max-width: 992px) and (max-width: 600px) {
  .navbar_mobile .rightSideContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 8px;
    margin-top: 5px;
  }
}
@media (max-width: 992px) {
  .navbar_mobile .rightSideContainer .btn-login {
    color: #fff;
    background-color: var(--undp-jtf-btn-dark-color);
    margin-left: 20px;
    font-family: "OpenSans-Bold";
    padding: 7px 35px;
  }
}
@media (max-width: 992px) and (max-width: 450px) {
  .navbar_mobile .rightSideContainer .btn-login {
    padding: 7px 14px;
  }
}
@media (max-width: 992px) {
  .navbar_mobile .rightSideContainer #user-dropdown {
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: -moz-fit-content;
    width: fit-content;
    padding: 0px 5px;
  }
  .navbar_mobile .rightSideContainer #user-dropdown:hover {
    text-decoration: none;
  }
  .custom-btn-create-incident {
    margin-left: 8px;
    border-radius: 8px;
    opacity: 1;
  }
}
.footer {
  position: absolute;
  bottom: 6px;
  left: 8px;
  width: calc(100% - 16px);
  font-size: 12px;
}
.footer a:hover {
  text-decoration: none;
}

.dropdown-item-checked::before {
  position: absolute;
  left: 0.4rem;
  content: "✓";
}

#langDropdown .dropdown-item {
  color: #fff;
}
#langDropdown .dropdown-item:hover {
  color: #fff;
  background-color: unset;
}

.offline {
  color: rgb(128, 128, 128);
}

.online {
  color: rgb(11, 161, 11);
}

.networkIcon {
  margin: 0px 0px -28px -24px;
}

.circleUserAvatar {
  border: 1px solid var(--undp-jtf-btn-text-color);
  width: 30px;
  height: 30px;
}

.messageIcon {
  width: 24px;
  float: left;
  height: 24px;
  opacity: 1;
  margin-left: 45%;
}

.padLeft50 {
  padding-left: 50%;
}

.margLeft45 {
  margin-left: 45%;
}

.notifRow {
  display: flex;
  margin-left: 61%;
}

.margLeft2 {
  margin-left: 2%;
}

.margLeft4 {
  margin-left: 4%;
}

.margLeft3 {
  margin-left: -3%;
}

.margLeft1 {
  margin-left: 1%;
}

.displayBlock {
  display: block;
}

.displayFlex {
  display: flex;
}

.userProfileText {
  text-align: left;
  letter-spacing: 0px;
  color: var(--undp-jtf-text-color);
  opacity: 1;
  font-size: 0.9em;
  width: 5rem;
}

.logoutText {
  text-align: left;
  letter-spacing: 0px;
  color: var(--undp-jtf-btn-text-color);
  font-size: 0.8em;
  opacity: 1;
}

.bgWhite {
  background-color: #ffffff;
}

.createReportDiv {
  border: 1px solid var(--undp-jtf-accent-color);
  border-radius: 10px;
  display: flex;
  opacity: 1;
  margin-left: 1%;
  width: 11.3em;
  padding: 0.5%;
}

.sideBarChildren {
  font-size: 12px;
}

.plusIcon {
  padding-left: 24%;
  font-size: 26px;
  color: var(--undp-jtf-accent-color);
  font-weight: bold;
}

.padLeft3 {
  padding-left: 3%;
}

.btnCreateIncident {
  background-color: var(--undp-jtf-btn-dark-color);
  color: var(--undp-jtf-btn-text-color);
  font-size: 14px;
  margin-left: 15px;
  border-radius: 10px;
  opacity: 1;
  min-width: 146px;
}
@media (max-width: 1340px) {
  .btnCreateIncident {
    min-width: 110px;
  }
}

.btnCreateIncident.focus,
.btnCreateIncident:focus {
  box-shadow: none;
}

.createReportSpan {
  display: flex;
  font-size: 1.2em;
  padding-left: 11%;
  white-space: nowrap;
  font-family: "OpenSans-Light";
  color: var(--undp-jtf-accent-color);
}

.roundCircle.countryCodeText {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--undp-jtf-text-color);
  font-family: "OpenSans-Bold";
  text-transform: uppercase;
  margin-right: 0.5em;
  margin-left: 1em;
}

.appLabel {
  text-transform: uppercase;
  color: #ffffff;
  font-family: "OpenSans-Bold";
  font-size: 1.4em;
  text-align: left;
  letter-spacing: 0px;
}

.nav-user-info {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-left: 1em;
}
.nav-user-info div {
  padding-left: 5px;
}

.height90 {
  height: 90vh;
}

.padSideBarList {
  padding: 1em;
}

.sideBarListText {
  padding-left: 0.2em;
  font-size: 14px;
}

.childItem {
  padding-left: 0;
  letter-spacing: 0;
  font-size: 13px;
  display: block;
}

.dividerLine {
  background-color: grey;
  margin-top: 0;
}

.childLink {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  color: var(--undp-jtf-text-header-color, #23191b);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;
}
.childLink__indicator {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: transparent;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.15s ease;
}
.childLink__label {
  line-height: 1.3;
  color: inherit;
}
.childLink:hover {
  background: rgba(0, 47, 108, 0.06);
  color: var(--undp-jtf-btn-dark-color, #002f6c);
}
.childLink.active {
  background: var(--undp-jtf-accent-color);
  color: #fff;
  font-weight: 600;
}
.childLink.active .childLink__label {
  color: #fff;
}
.childLink.active .childLink__indicator {
  background: #fff;
  transform: scale(1.35);
}

.fontSize12 {
  font-size: 12px;
}

.fontSize16 {
  font-size: 16px;
}

::placeholder {
  color: var(--undp-jtf-btn-text-color);
  text-align: left;
  letter-spacing: 0px;
  opacity: 0.3;
}

.floatRight {
  float: right;
}

.first-group {
  display: flex;
  flex-direction: column;
  margin-top: -2px;
}

.second-group {
  display: flex;
  flex-direction: column;
}

.customFlexNav {
  display: flex;
  height: 100%;
  justify-content: space-between;
  flex-wrap: nowrap;
}

.first-group span.childItem:hover .childLink:not(.active),
.second-group span.childItem:hover .childLink:not(.active) {
  background: rgba(0, 47, 108, 0.06);
  color: var(--undp-jtf-btn-dark-color);
}

.navItemParentLink {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--undp-jtf-link-dark-bg-color);
  flex-grow: 1;
  border-bottom: 4px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;
}

.nav-menu-chevron {
  font-size: 11px;
  opacity: 0.75;
  transition: transform 0.2s ease;
}

.navItemParentLink:hover,
.navItemParentLink.active,
.navItemParentLink.menu-parent-active {
  color: var(--undp-jtf-link-dark-bg-hover-color) !important;
  text-decoration: none;
  border-bottom-color: var(--undp-jtf-btn-dark-color);
}

.navItemParentLink.active,
.navItemParentLink.menu-parent-active {
  color: var(--undp-jtf-accent-color) !important;
  font-weight: 700;
}

.nav-menu-item--open > .navItemParentLink .nav-menu-chevron,
.nav-menu-item--active > .navItemParentLink .nav-menu-chevron {
  transform: rotate(180deg);
}

.category-title {
  margin: 0.5em 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.notification-row {
  display: flex;
  width: 2em;
  flex-direction: row;
  justify-content: space-evenly;
}

.pad-left-15 {
  padding-left: 15px;
}

.bg-main-body {
  background: #f4f4f4 0% 0% no-repeat padding-box;
  opacity: 0.98;
}

.custom-btn-create-incident {
  margin-left: 8px;
  border-radius: 8px;
  opacity: 1;
}

.txt-create-incident {
  padding-left: 5px;
  vertical-align: middle;
}

.dropdown-lang-item {
  color: var(--undp-jtf-link-dark-bg-hover-color) !important;
  cursor: pointer;
  text-transform: uppercase;
}

.bell-color {
  color: var(--undp-jtf-primary-color-transparent);
}

.createReport.dropdown-toggle::after {
  display: none !important;
}

.createReport .custom-btn-create-incident {
  border: none;
  color: #fff;
}

.circle-dot {
  border: none;
}

.logo {
  width: 7rem;
}
@media (max-width: 1410px) {
  .logo {
    width: 5rem;
  }
}
@media (max-width: 1092px) {
  .logo {
    width: 4.5rem;
  }
}
@media (max-width: 1060px) {
  .logo {
    width: 4rem;
  }
}
@media (max-width: 992px) {
  .logo {
    width: 7rem;
    margin-left: -30px;
  }
}
@media (max-width: 580px) {
  .logo {
    margin-left: 0px;
  }
}

.nav-user-info .childItem {
  padding-left: 0;
}
.nav-user-info ul.main-navigation {
  list-style: none;
  padding: 0;
  margin: 0;
  background: #fff;
}
.nav-user-info ul.main-navigation::before, .nav-user-info ul.main-navigation::after {
  content: " ";
  display: table;
}
.nav-user-info ul.main-navigation::after {
  clear: both;
}
.nav-user-info ul.main-navigation > li.nav-menu-item {
  display: block;
  position: relative;
  float: left;
  background: #fff;
}
.nav-user-info ul.main-navigation > li.nav-menu-item.nav-menu-item--has-children > a.navItemParentLink {
  cursor: pointer;
}
.nav-user-info ul.main-navigation > li.nav-menu-item > a.navItemParentLink {
  display: inline-flex;
  padding: 26px 1em;
  text-decoration: none;
  white-space: nowrap;
  color: var(--undp-jtf-text-color);
}
@media (max-width: 1290px) {
  .nav-user-info ul.main-navigation > li.nav-menu-item > a.navItemParentLink {
    padding: 24px 13px;
  }
}
@media (max-width: 1210px) {
  .nav-user-info ul.main-navigation > li.nav-menu-item > a.navItemParentLink {
    padding: 24px 0.625em;
  }
}
.nav-user-info ul.main-navigation > li.nav-menu-item.nav-menu-item--active > a.navItemParentLink {
  border-bottom-color: var(--undp-jtf-btn-dark-color);
}
.nav-user-info ul.main-navigation > li.nav-menu-item > ul.childItems {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 240px;
  margin: 0;
  padding: 6px 0;
  list-style: none;
  background: #fff;
  border: 1px solid rgba(0, 47, 108, 0.12);
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  z-index: 1000;
}
.nav-user-info ul.main-navigation > li.nav-menu-item > ul.childItems .childItem {
  color: var(--undp-jtf-text-header-color, #23191b);
}
.nav-user-info ul.main-navigation > li.nav-menu-item > ul.childItems .childLink {
  color: var(--undp-jtf-text-header-color, #23191b);
}
.nav-user-info ul.main-navigation > li.nav-menu-item > ul.childItems .childLink:hover {
  color: var(--undp-jtf-btn-dark-color, #002f6c);
}
.nav-user-info ul.main-navigation > li.nav-menu-item > ul.childItems .childItems__row {
  float: none;
  display: block;
  border-top: 1px solid rgba(0, 47, 108, 0.06);
}
.nav-user-info ul.main-navigation > li.nav-menu-item > ul.childItems .childItems__row:first-child {
  border-top: none;
}
.nav-user-info ul.main-navigation > li.nav-menu-item.nav-menu-item--open > ul.childItems {
  display: block;
}
.nav-user-info ul ul ul {
  left: 100%;
  top: 0;
}

.content-wrapper .about-us-body-container {
  display: flex;
  flex-direction: row;
  background-color: #4383c2;
  color: #fff;
  padding: 4rem 3rem 4rem 3rem;
  font-family: "OpenSans-Regular";
}
.content-wrapper .about-us-body-container .section-title {
  font: normal normal bold 24px/32px "OpenSans-Regular";
}
.content-wrapper .about-us-body-container .section-body {
  display: inline-block;
  margin-top: 25px;
  font: normal normal normal 14px/28px "OpenSans-Regular";
}
.content-wrapper .about-us-body-container .section-read-more-link {
  margin-top: 3rem;
  display: inline-block;
}
.content-wrapper .about-us-body-container .section-read-more-link a {
  color: #fff;
  text-decoration: none;
  font: normal normal normal 18px/24px "OpenSans-Regular";
}
.content-wrapper .about-us-body-container .section-read-more-link a:hover {
  color: #fff;
  text-decoration: none;
}
.content-wrapper .about-us-body-container .left-block-image {
  max-width: 42%;
}
.content-wrapper .about-us-body-container .left-block-image img {
  box-shadow: 12px 12px #8db4da;
  border-radius: 78px;
}
.content-wrapper .about-us-body-container .right-block {
  margin-left: 5rem;
}
.content-wrapper .footer-container {
  display: flex;
  flex-direction: row;
  background-color: #fff;
  color: var(--undp-jtf-btn-text-color);
  padding: 0rem 2rem 2rem 2rem;
}
.content-wrapper .footer-container .left-block {
  padding: 3rem;
}
.content-wrapper .footer-container .left-block:after {
  content: " ";
  position: absolute;
  border-left: 1px var(--undp-jtf-primary-color) solid;
  top: 20%;
  right: 0;
  height: 75%;
  margin-top: auto;
  margin-bottom: auto;
}
.content-wrapper .footer-container .left-block .section-title {
  font: normal normal bold 30px/39px "OpenSans-Regular";
}
.content-wrapper .footer-container .left-block .section-body {
  display: inline-block;
  margin-top: 25px;
  font: normal normal normal 14px/28px "OpenSans-Regular";
}
.content-wrapper .footer-container .left-block .section-read-more-link {
  margin-top: 3rem;
  display: inline-block;
}
.content-wrapper .footer-container .left-block .section-read-more-link a {
  color: #fff;
  text-decoration: none;
  background-color: #4383c2;
  padding: 1em 2em;
  border-radius: 8px;
}
.content-wrapper .footer-container .left-block .section-read-more-link a:hover {
  color: #fff;
  text-decoration: none;
  opacity: 0.9;
}
.content-wrapper .footer-container .right-block {
  padding: 3rem;
}
.content-wrapper .footer-container .right-block .section-title {
  font: normal normal bold 30px/39px "OpenSans-Regular";
}
.content-wrapper .footer-container .right-block .section-body {
  display: inline-block;
  margin-top: 25px;
  font: normal normal normal 14px/28px "OpenSans-Regular";
}
.content-wrapper .footer-container .right-block .section-read-more-link {
  margin-top: 3rem;
  display: inline-block;
}
.content-wrapper .footer-container .right-block .section-read-more-link a {
  color: #fff;
  text-decoration: none;
  background-color: #4383c2;
  padding: 1em 2em;
  border-radius: 8px;
}
.content-wrapper .footer-container .right-block .section-read-more-link a:hover {
  color: #fff;
  text-decoration: none;
  opacity: 0.9;
}

.color-logout {
  color: var(--undp-jtf-text-color);
}

.no-wrap {
  white-space: no-wrap;
}

/* Responsive layout - makes a one column layout instead of a two-column layout */
@media (max-width: 992px) {
  .content-wrapper .about-us-body-container {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./apps/hybrid-app/src/app/features/index/index.component.scss","webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;EAAA;AAAA;;EAAA;ADGA;EACE,cAAA;EACA,UAAA;AAKF;;AAFA;EACE,oBAAA;AAKF;;AAFA;EACE,oBAAA;AAKF;;AAFA;EACE,oBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AAKF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,yBAAA;AAMF;;AAJA;EACE,yBAAA;AAOF;;AALA;EACE,yBAAA;AAQF;;AANA;;EAEE,yBAAA;AASF;;AALE;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,8BAAA;AAQJ;AANI;EAPF;IAQI,eAAA;EASJ;AACF;AANE;EACE,aAAA;EAEA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAOJ;AAHE;EACE,4BEzDkB;EF0DlB,eAAA;EAGA,iCAAA;EACA,YAAA;AAGJ;AADI;EARF;IASI,eAAA;EAIJ;AACF;AAFI;EAZF;IAaI,eAAA;EAKJ;AACF;AAHI;EAhBF;IAiBI,eAAA;EAMJ;AACF;AAJI;EApBF;IAqBI,eAAA;EAOJ;AACF;AAJE;EACE,qBAAA;EACA,eAAA;EACA,gBAAA;AAMJ;AAJE;EACE,WAAA;EACA,0CAAA;EACA,sCAAA;AAMJ;AALI;EACE,yBAAA;EACA,+CAAA;AAON;AAJE;EACE,WAAA;EACA,gDAAA;EACA,iBAAA;EACA,4BEzGgB;EF0GhB,iBAAA;AAMJ;AALI;EACE,qBAAA;EACA,YAAA;AAON;AAJI;EAXF;IAYI,iBAAA;EAOJ;AACF;AALE;EACE,iBAAA;AAOJ;AALE;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EAAA,kBAAA;EACA,gBAAA;AAOJ;AANI;EACE,qBAAA;AAQN;AAJI;EACE,aAAA;EACA,cAAA;AAMN;AAJI;EACE,eAAA;EACA,aAAA;EACA,+CAAA;AAMN;AAHE;EACE,YAAA;AAKJ;AAFE;EACE,kBAAA;AAIJ;AAFE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,wCAAA;EACA,kBAAA;EACA,0CAAA;EACA,sBAAA;EACA,eAAA;AAIJ;AAFI;EACE,iDAAA;EACA,sBAAA;EACA,kBAAA;EACA,mDAAA;AAIN;AAFM;EAEE,kCAAA;EACA,8CAAA;AAGR;AACI;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AACN;AAAM;EAVF;IAWI,wBAAA;IACA,8BAAA;EAGN;AACF;AACE;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,cAAA;EACA,UAAA;AACJ;AACE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,UAAA;AACJ;AAEI;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAAN;AAGE;EACE,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AADJ;AAEI;EACE;IACE,aAAA;IACA,eAAA;EAAN;AACF;;AAKA;EACE,iCAAA;AAFF;;AAKA;EACE,aAAA;EACA,YAAA;EAEA,kBAAA;AAHF;AAIE;EALF;IAMI,cAAA;EADF;AACF;AAGE;EATF;IAUI,kBAAA;EAAF;AACF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,4BE9PoB;EF+PpB,iCAAA;AADF;AAGE;EATF;IAUI,eAAA;EAAF;AACF;;AAIE;EADF;IAEI,kBAAA;EAAF;AACF;;AAGA;EACE,iCAAA;EACA,gBAAA;EACA,eAAA;AAAF;AAEE;EACE,YAAA;EACA,WAAA;AAAJ;;AAIA;EACE,YAAA;AADF;AAIE;EAJF;IAKI,WAAA;EADF;AACF;AAGE;EARF;IASI,WAAA;EAAF;AACF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,uDAAA;EACA,4BE/SoB;EFgTpB,eAAA;EACA,gBAAA;EACA,gCAAA;AAAF;AAEE;EACE,8BAAA;EACA,gBAAA;AAAJ;AAEE;EApBF;IAqBI,WAAA;EACF;AACF;;AAGA;EACE,kCAAA;AAAF;;AAGA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;EACA,iCAAA;EACA,kBAAA;EACA,4CAAA;EACA,kCAAA;EACA,4EAAA;AAAF;AAEE;EAEE,iDAAA;EACA,kCAAA;EACA,qCAAA;EACA,gBAAA;AADJ;AAIE;EACE,qBAAA;EACA,iCAAA;AAFJ;AAKE;EACE,kBAAA;AAHJ;;AAiBA;EACE,WAAA;AAdF;;AAiBA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,+BEtXqB;EFuXrB,kCAAA;EACA,iCAAA;AAdF;AAgBE;EACE,cAAA;EACA,iBAAA;AAdJ;;AAkBA;EACE,qBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,iCAAA;EACA,4BAAA;EACA,4CAAA;EACA,kCAAA;EACA,4EAAA;AAfF;AAiBE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iCAAA;AAfJ;AAkBE;EACE,+CAAA;EACA,wCAAA;EACA,WAAA;EACA,gBAAA;AAhBJ;AAkBI;EACE,gBAAA;AAhBN;AAoBE;EACE,qBAAA;AAlBJ;;AA2BA;EACE,gDAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;AAxBF;;AA2BA;EACE,gDAAA;EACA,iBAAA;EACA,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BE7bkB;EF8blB,SAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,gDAAA;EACA,4BEpckB;EFqclB,iBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,cAAA;AAxBF;;AA0BA;EACE,kBAAA;AAvBF;AAyBE;EACE,yBAAA;AAvBJ;;AA+BA;EACE,yBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,YAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AA5BF;AA8BE;EACE,uBAAA;EACA,YAAA;EACA,gBAAA;AA5BJ;AA8BE;EACE,kBAAA;EACA,yBAAA;AA5BJ;AA8BE;EACE,gBAAA;EACA,WAAA;AA5BJ;AA6BI;EACE,mCAAA;AA3BN;AA+BM;EACE,cAAA;AA7BR;AAgCI;EACE,iBAAA;AA9BN;AAiCE;EACE;IAEE,gBAAA;EA/BJ;AACF;;AAmCA;EACE,kBAAA,EAAA,2BAAA;AAhCF;;AAkCA;EACE;IACE,iBAAA,EAAA,2BAAA;EA/BF;AACF;AAkCA;EACE;IACE,YAAA;EAhCF;EAkCA;IACE,6BAAA;EAhCF;EAmCE;IACE,eAAA;IACA,uBAAA;EAjCJ;AACF;AAqCA;EAIE;IACE,aAAA;EAtCF;EAuCE;IACE,eAAA;IACA,uBAAA;EArCJ;EAyCA;IACE,mBAAA;IACA,uBAAA;IACA,gBAAA;IACA,uBAAA;IAAA,kBAAA;IACA,sBAAA;EAvCF;EAyCA;IACE,eAAA;IACA,4BEljBkB;IFmjBlB,gBAAA;IACA,iCAAA;IACA,YAAA;EAvCF;EAyCA;IACE,YAAA;EAvCF;EAyCA;IACE,6BAAA;EAvCF;EA0CA;IACE,oCAAA;IACA,aAAA;EAxCF;EAyCE;IACE,eAAA;IACA,uBAAA;EAvCJ;EA0CE;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EAxCJ;EA2CE;IACE,oCAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,8BAAA;EAzCJ;EA6CA;IACE,oCAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,8BAAA;EA3CF;EA6CA;IACE,eAAA;EA3CF;EA6CA;IACE,aAAA;IAsDA,6EAAA;IAKA,oBAAA;EApGF;EA2CE;IACE,eAAA;EAzCJ;EA2CE;IACE,iBAAA;EAzCJ;EA2CE;IACE,gBAAA;IACA,aAAA;IACA,UAAA;IACA,SAAA;IACA,gBAAA;EAzCJ;EA0CI;IACE,cAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;EAxCN;EAyCM;IACE,aAAA;EAvCR;EAwCQ;IACE,YAAA;EAtCV;EAuCU;IACE,YAAA;EArCZ;EAyCM;IACE,qBAAA;IACA,2BAAA;IACA,qBAAA;IACA,mBAAA;IACA,iCAAA;EAvCR;EA0CM;IACE,cAAA;IACA,kBAAA;EAxCR;EA0CM;IACE,WAAA;EAxCR;EAkDE;IACE,aAAA;EAhDJ;EAmDE;IACE,UAAA;IACA,MAAA;EAjDJ;EAoDE;;IAEE,YAAA,EAAA,MAAA;IACA,cAAA,EAAA,MAAA;EAlDJ;EAoDE;IACE,WAAA;EAlDJ;EAqDA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,UAAA;IAGA,2BAAA;IACA,mBAAA;EArDF;AACF;AAsDI;EAVF;IAWI,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,mBAAA;IACA,eAAA;EAnDJ;AACF;AAvGA;EA4JI;IACE,WAAA;IACA,gDAAA;IACA,iBAAA;IACA,4BEnsBc;IFosBd,iBAAA;EAlDJ;AACF;AAmDM;EAPF;IAQI,iBAAA;EAhDN;AACF;AArHA;EAwKI;IACE,qBAAA;IACA,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,8BAAA;IACA,uBAAA;IAAA,kBAAA;IACA,gBAAA;EAhDJ;EAiDI;IACE,qBAAA;EA/CN;EAmDA;IAGE,gBAAA;IACA,kBAAA;IACA,UAAA;EAnDF;AACF;AAsDA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,wBAAA;EACA,eAAA;AApDF;AAsDI;EACE,qBAAA;AApDN;;AAwDA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AArDF;;AA0DE;EACE,WAAA;AAvDJ;AAwDI;EACE,WAAA;EACA,uBAAA;AAtDN;;AA0DA;EACE,yBAAA;AAvDF;;AAyDA;EACE,uBAAA;AAtDF;;AAwDA;EACE,2BAAA;AArDF;;AAwDA;EACE,gDAAA;EACA,WAAA;EACA,YAAA;AArDF;;AAwDA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,iBAAA;AArDF;;AAwDA;EACE,gBAAA;AArDF;;AAwDA;EACE,aAAA;EACA,gBAAA;AArDF;;AAwDA;EACE,eAAA;AArDF;;AAwDA;EACE,eAAA;AArDF;;AAwDA;EACE,gBAAA;AArDF;;AAwDA;EACE,eAAA;AArDF;;AAwDA;EACE,cAAA;AArDF;;AAwDA;EACE,aAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,mBAAA;EACA,iCAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;AArDF;;AAwDA;EACE,gBAAA;EACA,mBAAA;EACA,qCAAA;EACA,gBAAA;EACA,UAAA;AArDF;;AAwDA;EACE,yBAAA;AArDF;;AAwDA;EACE,8CAAA;EACA,mBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;AArDF;;AAwDA;EACE,eAAA;AArDF;;AAwDA;EACE,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,iBAAA;AArDF;;AAwDA;EACE,gBAAA;AArDF;;AAwDA;EACE,gDAAA;EACA,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;AArDF;AAuDE;EATF;IAUI,gBAAA;EApDF;AACF;;AA0DA;;EAEE,gBAAA;AAvDF;;AAyDA;EACE,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,6BE/3BmB;EFg4BnB,mCAAA;AAtDF;;AA8DE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,iCAAA;EACA,4BEl5BgB;EFm5BhB,yBAAA;EACA,mBAAA;EACA,gBAAA;AA3DJ;;AA8DA;EACE,yBAAA;EACA,cAAA;EACA,4BEr5BoB;EFs5BpB,gBAAA;EACA,gBAAA;EACA,mBAAA;AA3DF;;AA8DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AA3DF;AA4DE;EACE,iBAAA;AA1DJ;;AA8DA;EACE,YAAA;AA3DF;;AA8DA;EACE,YAAA;AA3DF;;AA8DA;EACE,mBAAA;EACA,eAAA;AA3DF;;AA+DA;EACE,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;AA5DF;;AA+DA;EACE,sBAAA;EACA,aAAA;AA5DF;;AA+DA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;EACA,qBAAA;EACA,mDAAA;AA5DF;AA8DE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,uDAAA;AA5DJ;AA+DE;EACE,gBAAA;EACA,cAAA;AA7DJ;AAgEE;EACE,kCAAA;EACA,8CAAA;AA9DJ;AAiEE;EACE,wCAAA;EACA,WAAA;EACA,gBAAA;AA/DJ;AAiEI;EACE,WAAA;AA/DN;AAkEI;EACE,gBAAA;EACA,sBAAA;AAhEN;;AAqEA;EACE,eAAA;AAlEF;;AAqEA;EACE,eAAA;AAlEF;;AAqEA;EACE,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAlEF;;AAqEA;EACE,YAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,sBAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,YAAA;EACA,8BAAA;EACA,iBAAA;AAlEF;;AAqEA;;EAEE,kCAAA;EACA,qCAAA;AAlEF;;AAqEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yCAAA;EACA,YAAA;EACA,oCAAA;EACA,yEAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,aAAA;EACA,+BAAA;AAlEF;;AAqEA;;;EAGE,0DAAA;EACA,qBAAA;EACA,mDAAA;AAlEF;;AAqEA;;EAEE,8CAAA;EACA,gBAAA;AAlEF;;AAqEA;;EAEE,yBAAA;AAlEF;;AAqEA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAlEF;;AAqEA;EACE,aAAA;EACA,UAAA;EACA,mBAAA;EACA,6BAAA;AAlEF;;AAqEA;EACE,kBAAA;AAlEF;;AAqEA;EACE,+CAAA;EACA,aAAA;AAlEF;;AAqEA;EACE,gBAAA;EACA,kBAAA;EACA,UAAA;AAlEF;;AAqEA;EACE,iBAAA;EACA,sBAAA;AAlEF;;AAqEA;EACE,0DAAA;EACA,eAAA;EACA,yBAAA;AAlEF;;AAqEA;EACE,gDAAA;AAlEF;;AAoEA;EACE,wBAAA;AAjEF;;AAmEA;EACE,YAAA;EACA,WAAA;AAhEF;;AAkEA;EACE,YAAA;AA/DF;;AAiEA;EACE,WAAA;AA9DF;AAuEE;EAVF;IAWI,WAAA;EApEF;AACF;AAsEE;EAdF;IAeI,aAAA;EAnEF;AACF;AAqEE;EAlBF;IAmBI,WAAA;EAlEF;AACF;AAoEE;EAtBF;IAuBI,WAAA;IACA,kBAAA;EAjEF;AACF;AAmEE;EA3BF;IA4BI,gBAAA;EAhEF;AACF;;AAqEE;EACE,eAAA;AAlEJ;AAqEE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAnEJ;AAqEI;EAEE,YAAA;EACA,cAAA;AApEN;AAuEI;EACE,WAAA;AArEN;AAwEI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAtEN;AAwEM;EACE,eAAA;AAtER;AAyEM;EACE,oBAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iCAAA;AAvER;AAyEQ;EAPF;IAQI,kBAAA;EAtER;AACF;AAwEQ;EAXF;IAYI,qBAAA;EArER;AACF;AAwEM;EACE,mDAAA;AAtER;AAyEM;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,0BAAA;EACA,0CAAA;EACA,aAAA;AAvER;AAyEQ;EACE,iDAAA;AAvEV;AA0EQ;EACE,iDAAA;AAxEV;AA0EU;EACE,8CAAA;AAxEZ;AA4EQ;EACE,WAAA;EACA,cAAA;EACA,4CAAA;AA1EV;AA4EU;EACE,gBAAA;AA1EZ;AA+EM;EACE,cAAA;AA7ER;AAkFE;EACE,UAAA;EACA,MAAA;AAhFJ;;AAuFE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,4BAAA;EACA,+BEjwCmB;AF6qCvB;AAqFI;EACE,qDAAA;AAnFN;AAqFI;EACE,qBAAA;EACA,gBAAA;EACA,uDAAA;AAnFN;AAqFI;EACE,gBAAA;EACA,qBAAA;AAnFN;AAoFM;EACE,WAAA;EACA,qBAAA;EACA,uDAAA;AAlFR;AAmFQ;EACE,WAAA;EACA,qBAAA;AAjFV;AAqFI;EACE,cAAA;AAnFN;AAoFM;EACE,6BAAA;EACA,mBAAA;AAlFR;AAqFI;EACE,iBAAA;AAnFN;AAuFE;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,qCAAA;EACA,4BAAA;AArFJ;AAsFI;EACE,aAAA;AApFN;AAsFM;EACE,YAAA;EACA,kBAAA;EACA,oDAAA;EACA,QAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AApFR;AAsFM;EACE,qDAAA;AApFR;AAsFM;EACE,qBAAA;EACA,gBAAA;EACA,uDAAA;AApFR;AAsFM;EACE,gBAAA;EACA,qBAAA;AApFR;AAqFQ;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAnFV;AAoFU;EACE,WAAA;EACA,qBAAA;EACA,YAAA;AAlFZ;AAuFI;EACE,aAAA;AArFN;AAsFM;EACE,qDAAA;AApFR;AAsFM;EACE,qBAAA;EACA,gBAAA;EACA,uDAAA;AApFR;AAsFM;EACE,gBAAA;EACA,qBAAA;AApFR;AAqFQ;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;AAnFV;AAqFU;EACE,WAAA;EACA,qBAAA;EACA,YAAA;AAnFZ;;AA2FA;EACE,iCAAA;AAxFF;;AA2FA;EACE,oBAAA;AAxFF;;AA0FA,iFAAA;AACA;EAGI;IACE,sBAAA;EAzFJ;AACF","sourcesContent":["@import '@eview/scss/index';\n@import '../../../scss/variables';\n\n::ng-deep .modal-lg {\n  max-width: 95%;\n  width: 95%;\n}\n\n::ng-deep .customModalWindowClass .modal-content {\n  pointer-events: auto;\n}\n\n::ng-deep .customModalWindowClass .modal-body {\n  pointer-events: auto;\n}\n\n.navbar-brand {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  padding-left: 1rem;\n  font-size: 1rem;\n  width: 250px;\n  margin: 0;\n}\n\nbody a {\n  color: #48557e;\n}\n#yt_header {\n  background-color: #3b746b;\n}\n#yt_spotlight {\n  background-color: #f1f1f1;\n}\n#yt_spotlight9 {\n  background-color: #48557e;\n}\n#yt_spotlight7,\n#yt_footer {\n  background-color: #3b746b;\n}\n\n.navbar {\n  .nav-container {\n    width: 97%;\n    display: flex;\n    flex-direction: row;\n    margin: 0 auto;\n    justify-content: space-between;\n    // min-width: fit-content;\n    @media (max-width: 1100px) {\n      max-width: 100%;\n    }\n  }\n\n  .button-wrapper {\n    display: flex;\n    //justify-content: space-between;\n    flex-grow: 1;\n    flex-wrap: wrap-reverse;\n    align-items: center;\n    height: 80px;\n    //margin: 5px 0px;\n    //padding-right: 73px;\n  }\n  .header-tagline {\n    font-family: $secondary-font-bold;\n    font-size: 20px;\n  //  font-weight: 500;\n    // padding: 10px 25px;\n    color: var(--undp-jtf-text-color);\n    margin: auto;\n\n    @media (max-width: 1410px) {\n      font-size: 18px;\n    }\n\n    @media (max-width: 1280px) {\n      font-size: 17px;\n    }\n\n    @media (max-width: 1060px) {\n      font-size: 14px;\n    }\n\n    @media (max-width: 992px) {\n      font-size: 22px;\n    }\n    // margin-right: 5%;\n  }\n  .form-control {\n    padding: 0.75rem 1rem;\n    border-width: 0;\n    border-radius: 0;\n  }\n  .form-control-dark {\n    color: #fff;\n    background-color: rgba(255, 255, 255, 0.1);\n    border-color: rgba(255, 255, 255, 0.1);\n    &:focus {\n      border-color: transparent;\n      box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.25);\n    }\n  }\n  .btn-login {\n    color: #fff;\n    background-color: var(--undp-jtf-btn-dark-color);\n    margin-left: 20px;\n    font-family: $primary-font-bold;\n    padding: 7px 35px;\n    &:hover {\n      text-decoration: none;\n      opacity: 0.9;\n    }\n\n    @media (max-width: 1160px) {\n      margin-left: 10px;\n    }\n  }\n  fa-icon {\n    margin-right: 4px;\n  }\n  #user-dropdown {\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    width: fit-content;\n    padding: 0px 3px;\n    &:hover {\n      text-decoration: none;\n    }\n  }\n  #reportDropdown {\n    .dropdown-menu {\n      margin-top: 0;\n      margin-left: 0;\n    }\n    .create-incident-ddbtn {\n      cursor: pointer;\n      padding: 10px;\n      color: var(--undp-jtf-link-dark-bg-hover-color);\n    }\n  }\n  .dropdown-toggle::after {\n    opacity: 0.5;\n  }\n\n  .user-dropdown-section {\n    position: relative;\n  }\n  .dropdown-menu {\n    position: absolute;\n    right: 10px;\n    left: auto;\n    top: 35px;\n    margin-top: 4px;\n    padding: 6px 0;\n    border: 1px solid rgba(0, 47, 108, 0.12);\n    border-radius: 8px;\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n    background-color: #fff;\n    font-size: 14px;\n\n    .dropdown-item {\n      color: var(--undp-jtf-text-header-color, #23191b);\n      background-color: #fff;\n      padding: 10px 16px;\n      transition: background 0.15s ease, color 0.15s ease;\n\n      &:hover,\n      &:focus {\n        background: rgba(0, 47, 108, 0.06);\n        color: var(--undp-jtf-btn-dark-color, #002f6c);\n      }\n    }\n\n    &.notifications-dropdown {\n      right: -17px;\n      left: unset;\n      width: 400px;\n      padding-top: 4px;\n      padding-bottom: unset;\n      max-height: 50vh;\n      overflow-y: scroll;\n      overflow-x: hidden;\n      padding: 0;\n      @media (max-width: 767px) {\n        width: calc(100vw + 2px);\n        max-height: calc(100vh - 48px);\n      }\n    }\n  }\n\n  .unread-notifications {\n    position: absolute;\n    top: 4px;\n    right: 0;\n    font-size: 6px;\n    color: red;\n  }\n  .rightSideContainer {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    padding: 0;\n    //margin: 0 1em;\n    // flex-basis: 180px;\n    .fa-search {\n      border-right: 1px solid;\n      padding-right: 20px;\n      padding-left: 20px;\n      cursor: pointer;\n    }\n  }\n  .header-logo {\n    cursor: pointer;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    @media (min-width: 768px) {\n      .col-md-3 {\n        flex: 0 0 25%;\n        max-width: 100%;\n      }\n    }\n  }\n}\n\n.navbar.bg-dark {\n  background-color: #fff !important;\n}\n\n.mobile-nav {\n  display: none;\n  height: 70px;\n\n  padding: 10px 20px;\n  @media (max-width: 992px) {\n    display: block;\n  }\n\n  @media (max-width: 560px) {\n    padding: 10px 10px;\n  }\n\n}\n\n.mobile-nav-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.mobile-header-logo {\n  display: flex;\n  flex-direction: row;\n  width: fit-content;\n  align-items: center;\n  font-size: 18px;\n  font-family: $secondary-font-bold;\n  color: var(--undp-jtf-text-color);\n\n  @media (max-width: 560px) {\n    font-size: 16px;\n  }\n}\n\n.mobile-heading {\n  @media (max-width: 560px) {\n    text-align: center;\n  }\n}\n\n.mobile-dropdown-icon {\n  color: var(--undp-jtf-text-color);\n  margin: 0px 10px;\n  cursor: pointer;\n\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n}\n\n.mobile-logo {\n  width: 100px;\n  // height: 60px;\n\n  @media (max-width: 560px) {\n    width: 80px;\n  }\n\n  @media (max-width: 328px) {\n    width: 60px;\n  }\n}\n\n.mobile-dropdown {\n  position: absolute;\n  top: 70px;\n  right: 0;\n  z-index: 2;\n  width: 350px;\n  background: white;\n  color: var(--undp-jtf-text-color);\n  display: flex;\n  flex-direction: column;\n  border-bottom: 1px solid var(--undp-jtf-btn-text-color);\n  font-family: $secondary-font-bold;\n  max-height: 0px;\n  overflow: hidden;\n  box-shadow: -1px 2px 1px #d8d8d8;\n\n  &.mobile-dropdown-active {\n    max-height: calc(100vh - 70px);\n    overflow-y: auto;\n  }\n  @media (max-width: 560px) {\n    width: 100%;\n  }\n\n}\n\n.mobile-parentLink-div--active {\n  background: rgba(0, 47, 108, 0.04);\n}\n\n.mobile-parentLink {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  text-decoration: none;\n  color: var(--undp-jtf-text-color);\n  padding: 12px 16px;\n  border-top: 1px solid rgba(0, 47, 108, 0.12);\n  border-left: 4px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &--active,\n  &--route-active {\n    border-left-color: var(--undp-jtf-btn-dark-color);\n    background: rgba(0, 47, 108, 0.06);\n    color: var(--undp-jtf-btn-dark-color);\n    font-weight: 700;\n  }\n\n  &:active {\n    text-decoration: none;\n    color: var(--undp-jtf-text-color);\n  }\n\n  input {\n    position: absolute;\n    // opacity: 0;\n    // z-index: -1;\n\n    // &:checked ~ .mobile-parentLink-children {\n    //   display: block;\n    // }\n  }\n\n  // &:last-child {\n  //   border-bottom: 1px solid var(--undp-jtf-text-color);\n  // }\n}\n\n.mobile-parentLink-div {\n  width: 100%;\n}\n\n.mobile-parentLink-children {\n  display: none;\n  max-height: 0;\n  overflow: hidden;\n  font-family: $primary-font-regular;\n  background: rgba(0, 47, 108, 0.03);\n  transition: max-height 0.25s ease;\n\n  &-active {\n    display: block;\n    max-height: 480px;\n  }\n}\n\n.mobile-childLink {\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  color: var(--undp-jtf-text-color);\n  padding: 10px 16px 10px 32px;\n  border-top: 1px solid rgba(0, 47, 108, 0.08);\n  border-left: 4px solid transparent;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n\n  &::before {\n    content: '';\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    margin-right: 10px;\n    background: transparent;\n    flex-shrink: 0;\n    transition: background 0.15s ease;\n  }\n\n  &--active {\n    border-left-color: var(--undp-jtf-accent-color);\n    background: var(--undp-jtf-accent-color);\n    color: #fff;\n    font-weight: 600;\n\n    &::before {\n      background: #fff;\n    }\n  }\n\n  &:active {\n    text-decoration: none;\n  }\n\n  // &:last-child {\n  //   text-decoration: none;\n  //   color: var(--undp-jtf-text-color);\n  // }\n}\n\n.mobile-block {\n  border-top: 1px solid var(--undp-jtf-text-color);\n  padding-top: 10px;\n  padding-bottom: 10px;\n  display: flex;\n  justify-content: center;\n}\n\n.mobile-block-userInfo {\n  border-top: 1px solid var(--undp-jtf-text-color);\n  padding-top: 10px;\n  padding-bottom: 10px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-left: 16px;\n  font-family: $primary-font-bold;\n  gap: 10px;\n}\n\n.mobile-login-btn {\n  color: #fff;\n  background-color: var(--undp-jtf-btn-dark-color);\n  font-family: $primary-font-bold;\n  padding: 3px 14px;\n  width: fit-content;\n  margin: 0 auto;\n}\n.mobile-parentLink-caret {\n  margin-right: 15px;\n  // transition: transform 0.2 ease;\n  &-rotate {\n    transform: rotate(180deg);\n  }\n}\n\n// .mobile-parentLink-div:focus-within > .mobile-parentLink-children {\n\n// }\n\n.mobile-parentLink-div:focus-within > .mobile-parentLink-caret {\n  transform: rotate(180deg);\n}\n\n.mobile-dropdown-container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.main-body {\n  flex-grow: 1;\n}\n\n.sidebar {\n  flex-basis: 250px;\n  flex-direction: column;\n  display: flex;\n  height: calc(100vh - 57px);\n  min-width: 250px;\n\n  .sidebar-sticky {\n    justify-content: center;\n    height: 100%;\n    margin-top: 10px;\n  }\n  .sidebar-heading {\n    font-size: 0.75rem;\n    text-transform: uppercase;\n  }\n  .nav-link {\n    font-weight: 500;\n    color: #333;\n    &.active {\n      color: var(--undp-jtf-accent-color);\n    }\n    &.active,\n    &.hover {\n      .feather {\n        color: inherit;\n      }\n    }\n    fa-icon {\n      margin-right: 4px;\n    }\n  }\n  @supports ((position: -webkit-sticky) or (position: sticky)) {\n    .sidebar-sticky {\n      position: -webkit-sticky;\n      position: sticky;\n    }\n  }\n}\n\n[role='main'] {\n  padding-top: 133px; /* Space for fixed navbar */\n}\n@media (min-width: 768px) {\n  [role='main'] {\n    padding-top: 48px; /* Space for fixed navbar */\n  }\n}\n\n@media (max-width: 688px) {\n  .appLabel {\n    flex-grow: 1;\n  }\n  .btnCreateIncident {\n    margin: 1em 0.4em 0.5em 0.4em;\n  }\n  .navbar {\n    .button-wrapper {\n      margin: 0.5em 0;\n      flex-wrap: wrap-reverse;\n    }\n  }\n}\n\n@media (max-width: 992px) {\n  // .logo{\n  //   display: none;\n  // }\n  .navbar {\n    display: none;\n    .button-wrapper {\n      margin: 0.5em 0;\n      flex-wrap: wrap-reverse;\n    }\n  }\n\n  .header-logo {\n    align-items: center;\n    justify-content: center;\n    margin-top: 10px;\n    width: fit-content;\n    word-break: break-word;\n  }\n  .header-tagline {\n    font-size: 22px;\n    font-family: $secondary-font-bold;\n    font-weight: 500;\n    color: var(--undp-jtf-text-color);\n    margin: auto;\n  }\n  .appLabel {\n    flex-grow: 1;\n  }\n  .btnCreateIncident {\n    margin: 1em 0.4em 0.5em 0.4em;\n  }\n\n  .navbar_mobile {\n    background-color: #ffffff !important;\n    display: flex;\n    .button-wrapper {\n      margin: 0.5em 0;\n      flex-wrap: wrap-reverse;\n    }\n\n    .container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    }\n\n    .bg-dark .container {\n      background-color: #ffffff !important;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      flex-direction: column-reverse;\n    }\n  }\n\n  .navbar_mobile .bg-dark .container {\n    background-color: #ffffff !important;\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    flex-direction: column-reverse;\n  }\n  .sideBarListText {\n    font-size: 10px;\n  }\n  .nav-user-info {\n    display: flex;\n    // margin-top: 10px;\n    .childItem {\n      padding-left: 0;\n    }\n    img {\n      margin-left: 10px;\n    }\n    ul {\n      list-style: none;\n      display: flex;\n      padding: 0;\n      margin: 0;\n      background: #fff;\n      li {\n        display: block;\n        position: relative;\n        float: left;\n        background: #fff;\n        ul {\n          display: none;\n          li {\n            z-index: 999;\n            a {\n              padding: 1em;\n            }\n          }\n        }\n        a {\n          display: inline-block;\n          padding: 5px 5px !important;\n          text-decoration: none;\n          white-space: nowrap;\n          color: var(--undp-jtf-text-color);\n          //&:hover { background: #2c3e50; }\n        }\n        &:hover > ul {\n          display: block;\n          position: absolute;\n        }\n        &:hover li {\n          float: none;\n        }\n        &:hover a {\n          //background: var(--undp-jtf-btn-dark-color);\n        }\n        &:hover li a:hover {\n          //\tbackground: #2c3e50;\n        }\n      }\n    }\n    .main-navigation li ul li {\n      border-top: 0;\n    }\n    /* Displays second level dropdowns to the right of the first level dropdown */\n    ul ul ul {\n      left: 100%;\n      top: 0;\n    }\n    /* Simple clearfix */\n    ul:before,\n    ul:after {\n      content: ' '; /* 1 */\n      display: table; /* 2 */\n    }\n    ul:after {\n      clear: both;\n    }\n  }\n  .navbar_mobile .rightSideContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    //margin: 0 1em;\n    // flex-basis: 180px;\n    flex-direction: row-reverse;\n    padding-bottom: 8px;\n\n    @media (max-width: 600px) {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      padding-bottom: 8px;\n      margin-top: 5px;\n    }\n\n    .btn-login {\n      color: #fff;\n      background-color: var(--undp-jtf-btn-dark-color);\n      margin-left: 20px;\n      font-family: $primary-font-bold;\n      padding: 7px 35px;\n\n      @media (max-width: 450px) {\n        padding: 7px 14px;\n      }\n    }\n\n    #user-dropdown {\n      text-decoration: none;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      justify-content: space-between;\n      width: fit-content;\n      padding: 0px 5px;\n      &:hover {\n        text-decoration: none;\n      }\n    }\n  }\n  .custom-btn-create-incident {\n    // margin-bottom: -75px;\n    // margin-left: -285px !important;\n    margin-left: 8px;\n    border-radius: 8px;\n    opacity: 1;\n  }\n}\n\n.footer {\n  position: absolute;\n  bottom: 6px;\n  left: 8px;\n  width: calc(100% - (8px * 2));\n  font-size: 12px;\n  a {\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n.dropdown-item-checked::before {\n  position: absolute;\n  left: 0.4rem;\n  content: '\\2713';\n//  font-weight: 600;\n}\n\n#langDropdown {\n  .dropdown-item {\n    color: #fff;\n    &:hover {\n      color: #fff;\n      background-color: unset;\n    }\n  }\n}\n.offline {\n  color: rgb(128, 128, 128);\n}\n.online {\n  color: rgb(11, 161, 11);\n}\n.networkIcon {\n  margin: 0px 0px -28px -24px;\n}\n\n.circleUserAvatar {\n  border: 1px solid var(--undp-jtf-btn-text-color);\n  width: 30px;\n  height: 30px;\n}\n\n.messageIcon {\n  width: 24px;\n  float: left;\n  height: 24px;\n  opacity: 1;\n  margin-left: 45%;\n}\n\n.padLeft50 {\n  padding-left: 50%;\n}\n\n.margLeft45 {\n  margin-left: 45%;\n}\n\n.notifRow {\n  display: flex;\n  margin-left: 61%;\n}\n\n.margLeft2 {\n  margin-left: 2%;\n}\n\n.margLeft4 {\n  margin-left: 4%;\n}\n\n.margLeft3 {\n  margin-left: -3%;\n}\n\n.margLeft1 {\n  margin-left: 1%;\n}\n\n.displayBlock {\n  display: block;\n}\n\n.displayFlex {\n  display: flex;\n}\n\n.userProfileText {\n  text-align: left;\n  letter-spacing: 0px;\n  color: var(--undp-jtf-text-color);\n  opacity: 1;\n  font-size: 0.9em;\n  width: 5rem;\n}\n\n.logoutText {\n  text-align: left;\n  letter-spacing: 0px;\n  color: var(--undp-jtf-btn-text-color);\n  font-size: 0.8em;\n  opacity: 1;\n}\n\n.bgWhite {\n  background-color: #ffffff;\n}\n\n.createReportDiv {\n  border: 1px solid var(--undp-jtf-accent-color);\n  border-radius: 10px;\n  display: flex;\n  opacity: 1;\n  margin-left: 1%;\n  width: 11.3em;\n  padding: 0.5%;\n}\n\n.sideBarChildren {\n  font-size: 12px;\n}\n\n.plusIcon {\n  padding-left: 24%;\n  font-size: 26px;\n  color: var(--undp-jtf-accent-color);\n  font-weight: bold;\n}\n\n.padLeft3 {\n  padding-left: 3%;\n}\n\n.btnCreateIncident {\n  background-color: var(--undp-jtf-btn-dark-color);\n  color: var(--undp-jtf-btn-text-color);\n  font-size: 14px;\n  margin-left: 15px;\n  border-radius: 10px;\n  opacity: 1;\n  min-width: 146px;\n\n  @media (max-width: 1340px) {\n    min-width: 110px;\n  }\n  // @media  (max-width: 688px) {\n  //   min-width: 110px;\n  // }\n}\n\n.btnCreateIncident.focus,\n.btnCreateIncident:focus {\n  box-shadow: none;\n}\n.createReportSpan {\n  display: flex;\n  font-size: 1.2em;\n  padding-left: 11%;\n  white-space: nowrap;\n  font-family: $primary-font-light;\n  color: var(--undp-jtf-accent-color);\n}\n.roundCircle {\n  // border-radius: 50%;\n  // border: 1px solid #264952;\n  // width: 45px;\n  // height: 45px;\n\n  &.countryCodeText {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    color: var(--undp-jtf-text-color);\n    font-family: $primary-font-bold;\n    text-transform: uppercase;\n    margin-right: 0.5em;\n    margin-left: 1em;\n  }\n}\n.appLabel {\n  text-transform: uppercase;\n  color: #ffffff;\n  font-family: $secondary-font-bold;\n  font-size: 1.4em;\n  text-align: left;\n  letter-spacing: 0px;\n}\n\n.nav-user-info {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  margin-left: 1em;\n  div {\n    padding-left: 5px;\n  }\n}\n\n.height90 {\n  height: 90vh;\n}\n\n.padSideBarList {\n  padding: 1em;\n}\n\n.sideBarListText {\n  padding-left: 0.2em;\n  font-size: 14px;\n // font-weight: bold;\n}\n\n.childItem {\n  padding-left: 0;\n  letter-spacing: 0;\n  font-size: 13px;\n  display: block;\n}\n\n.dividerLine {\n  background-color: grey;\n  margin-top: 0;\n}\n\n.childLink {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  color: var(--undp-jtf-text-header-color, #23191b);\n  text-decoration: none;\n  transition: background 0.15s ease, color 0.15s ease;\n\n  &__indicator {\n    width: 4px;\n    height: 4px;\n    border-radius: 50%;\n    background: transparent;\n    flex-shrink: 0;\n    transition: background 0.15s ease, transform 0.15s ease;\n  }\n\n  &__label {\n    line-height: 1.3;\n    color: inherit;\n  }\n\n  &:hover {\n    background: rgba(0, 47, 108, 0.06);\n    color: var(--undp-jtf-btn-dark-color, #002f6c);\n  }\n\n  &.active {\n    background: var(--undp-jtf-accent-color);\n    color: #fff;\n    font-weight: 600;\n\n    .childLink__label {\n      color: #fff;\n    }\n\n    .childLink__indicator {\n      background: #fff;\n      transform: scale(1.35);\n    }\n  }\n}\n\n.fontSize12 {\n  font-size: 12px;\n}\n\n.fontSize16 {\n  font-size: 16px;\n}\n\n::placeholder {\n  color: var(--undp-jtf-btn-text-color);\n  text-align: left;\n  letter-spacing: 0px;\n  opacity: 0.3;\n}\n\n.floatRight {\n  float: right;\n}\n\n.first-group {\n  display: flex;\n  flex-direction: column;\n  margin-top: -2px;\n}\n\n.second-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.customFlexNav {\n  display: flex;\n  height: 100%;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n}\n\n.first-group span.childItem:hover .childLink:not(.active),\n.second-group span.childItem:hover .childLink:not(.active) {\n  background: rgba(0, 47, 108, 0.06);\n  color: var(--undp-jtf-btn-dark-color);\n}\n\n.navItemParentLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--undp-jtf-link-dark-bg-color);\n  flex-grow: 1;\n  border-bottom: 4px solid transparent;\n  transition: color 0.2s ease, border-color 0.2s ease, background 0.2s ease;\n}\n\n.nav-menu-chevron {\n  font-size: 11px;\n  opacity: 0.75;\n  transition: transform 0.2s ease;\n}\n\n.navItemParentLink:hover,\n.navItemParentLink.active,\n.navItemParentLink.menu-parent-active {\n  color: var(--undp-jtf-link-dark-bg-hover-color) !important;\n  text-decoration: none;\n  border-bottom-color: var(--undp-jtf-btn-dark-color);\n}\n\n.navItemParentLink.active,\n.navItemParentLink.menu-parent-active {\n  color: var(--undp-jtf-accent-color) !important;\n  font-weight: 700;\n}\n\n.nav-menu-item--open > .navItemParentLink .nav-menu-chevron,\n.nav-menu-item--active > .navItemParentLink .nav-menu-chevron {\n  transform: rotate(180deg);\n}\n\n.category-title {\n  margin: 0.5em 0;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.notification-row {\n  display: flex;\n  width: 2em;\n  flex-direction: row;\n  justify-content: space-evenly;\n}\n\n.pad-left-15 {\n  padding-left: 15px;\n}\n\n.bg-main-body {\n  background: #f4f4f4 0% 0% no-repeat padding-box;\n  opacity: 0.98;\n}\n\n.custom-btn-create-incident {\n  margin-left: 8px;\n  border-radius: 8px;\n  opacity: 1;\n}\n\n.txt-create-incident {\n  padding-left: 5px;\n  vertical-align: middle;\n}\n\n.dropdown-lang-item {\n  color: var(--undp-jtf-link-dark-bg-hover-color) !important;\n  cursor: pointer;\n  text-transform: uppercase;\n}\n\n.bell-color {\n  color: var(--undp-jtf-primary-color-transparent);\n}\n.createReport.dropdown-toggle::after {\n  display: none !important;\n}\n.createReport .custom-btn-create-incident {\n  border: none;\n  color: #fff;\n}\n.circle-dot {\n  border: none;\n}\n.logo {\n  width: 7rem;\n  // height: 100%;\n  // margin: auto;\n  // padding: 10px;\n  // margin-left: -50%;\n  // padding-right: 30px;\n\n  //padding-left: 73px;\n\n  @media (max-width: 1410px) {\n    width: 5rem;\n  }\n\n  @media (max-width: 1092px) {\n    width: 4.5rem;\n  }\n\n  @media (max-width: 1060px) {\n    width: 4rem;\n  }\n\n  @media (max-width: 992px) {\n    width: 7rem;\n    margin-left: -30px;\n  }\n\n  @media (max-width: 580px) {\n    margin-left: 0px;\n  }\n}\n\n// CSS For Menu navigation\n.nav-user-info {\n  .childItem {\n    padding-left: 0;\n  }\n\n  ul.main-navigation {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    background: #fff;\n\n    &::before,\n    &::after {\n      content: ' ';\n      display: table;\n    }\n\n    &::after {\n      clear: both;\n    }\n\n    > li.nav-menu-item {\n      display: block;\n      position: relative;\n      float: left;\n      background: #fff;\n\n      &.nav-menu-item--has-children > a.navItemParentLink {\n        cursor: pointer;\n      }\n\n      > a.navItemParentLink {\n        display: inline-flex;\n        padding: 26px 1em;\n        text-decoration: none;\n        white-space: nowrap;\n        color: var(--undp-jtf-text-color);\n\n        @media (max-width: 1290px) {\n          padding: 24px 13px;\n        }\n\n        @media (max-width: 1210px) {\n          padding: 24px 0.625em;\n        }\n      }\n\n      &.nav-menu-item--active > a.navItemParentLink {\n        border-bottom-color: var(--undp-jtf-btn-dark-color);\n      }\n\n      > ul.childItems {\n        display: none;\n        position: absolute;\n        top: 100%;\n        left: 0;\n        min-width: 240px;\n        margin: 0;\n        padding: 6px 0;\n        list-style: none;\n        background: #fff;\n        border: 1px solid rgba(0, 47, 108, 0.12);\n        border-radius: 0 0 8px 8px;\n        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);\n        z-index: 1000;\n\n        .childItem {\n          color: var(--undp-jtf-text-header-color, #23191b);\n        }\n\n        .childLink {\n          color: var(--undp-jtf-text-header-color, #23191b);\n\n          &:hover {\n            color: var(--undp-jtf-btn-dark-color, #002f6c);\n          }\n        }\n\n        .childItems__row {\n          float: none;\n          display: block;\n          border-top: 1px solid rgba(0, 47, 108, 0.06);\n\n          &:first-child {\n            border-top: none;\n          }\n        }\n      }\n\n      &.nav-menu-item--open > ul.childItems {\n        display: block;\n      }\n    }\n  }\n\n  ul ul ul {\n    left: 100%;\n    top: 0;\n  }\n}\n\n// Homepage About Us section\n.content-wrapper {\n  // margin-top: 55px;\n  .about-us-body-container {\n    display: flex;\n    flex-direction: row;\n    background-color: #4383c2;\n    color: #fff;\n    padding: 4rem 3rem 4rem 3rem;\n    font-family: $primary-font-regular;\n    .section-title {\n      font: normal normal bold 24px/32px $primary-font-regular;\n    }\n    .section-body {\n      display: inline-block;\n      margin-top: 25px;\n      font: normal normal normal 14px/28px $primary-font-regular;\n    }\n    .section-read-more-link {\n      margin-top: 3rem;\n      display: inline-block;\n      a {\n        color: #fff;\n        text-decoration: none;\n        font: normal normal normal 18px/24px $primary-font-regular;\n        &:hover {\n          color: #fff;\n          text-decoration: none;\n        }\n      }\n    }\n    .left-block-image {\n      max-width: 42%;\n      img {\n        box-shadow: 12px 12px #8db4da;\n        border-radius: 78px;\n      }\n    }\n    .right-block {\n      margin-left: 5rem;\n    }\n  }\n\n  .footer-container {\n    display: flex;\n    flex-direction: row;\n    background-color: #fff;\n    color: var(--undp-jtf-btn-text-color);\n    padding: 0rem 2rem 2rem 2rem;\n    .left-block {\n      padding: 3rem;\n      // Code for right side border with height adjustment\n      &:after {\n        content: ' ';\n        position: absolute;\n        border-left: 1px var(--undp-jtf-primary-color) solid;\n        top: 20%;\n        right: 0;\n        height: 75%;\n        margin-top: auto;\n        margin-bottom: auto;\n      }\n      .section-title {\n        font: normal normal bold 30px/39px $primary-font-regular;\n      }\n      .section-body {\n        display: inline-block;\n        margin-top: 25px;\n        font: normal normal normal 14px/28px $primary-font-regular;\n      }\n      .section-read-more-link {\n        margin-top: 3rem;\n        display: inline-block;\n        a {\n          color: #fff;\n          text-decoration: none;\n          background-color: #4383c2;\n          padding: 1em 2em;\n          border-radius: 8px;\n          &:hover {\n            color: #fff;\n            text-decoration: none;\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n    .right-block {\n      padding: 3rem;\n      .section-title {\n        font: normal normal bold 30px/39px $primary-font-regular;\n      }\n      .section-body {\n        display: inline-block;\n        margin-top: 25px;\n        font: normal normal normal 14px/28px $primary-font-regular;\n      }\n      .section-read-more-link {\n        margin-top: 3rem;\n        display: inline-block;\n        a {\n          color: #fff;\n          text-decoration: none;\n          background-color: #4383c2;\n          padding: 1em 2em;\n          border-radius: 8px;\n\n          &:hover {\n            color: #fff;\n            text-decoration: none;\n            opacity: 0.9;\n          }\n        }\n      }\n    }\n  }\n}\n\n.color-logout {\n  color: var(--undp-jtf-text-color);\n}\n\n.no-wrap {\n  white-space: no-wrap;\n}\n/* Responsive layout - makes a one column layout instead of a two-column layout */\n@media (max-width: 992px) {\n  .content-wrapper {\n    // margin-top: 145px;\n    .about-us-body-container {\n      flex-direction: column;\n    }\n  }\n}\n","/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
